export default __webpack_public_path__ + "locales/sk/Ldap.json?hash=dfc890053c7748d014e4647d329ab189";